class MHeader extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        headers: ['header'],
        logos: ['.m-logo'],
        topbar: '.m-topbar',
        headerWrapper: '.m-header__wrapper',
        topbarClose: '.m-topbar__close',
      }),
      (this.domNodes = queryDomNodes(this.selectors, this)),
      (this.innerWidth = window.innerWidth),
      (this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop),
      (this.headerHeight = this.domNodes.headerWrapper.offsetHeight),
      (this.stickyEnabled = 'true' === this.dataset.sticky || !1),
      (this.classes = {
        scrollUp: 'scroll-up',
        scrollDown: 'scroll-down',
        stuck: 'stuck',
      }),
      this.init()
  }
  init() {
    ;(this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && 'true' === this.domNodes.headers[0].dataset.transparent),
      this.initAddon(),
      this.handleSticky(),
      document.addEventListener('matchMobile', () => this.handleSticky()),
      document.addEventListener('unmatchMobile', () => this.handleSticky()),
      (this.siteNav = new SiteNav(this)),
      (window.__sfHeader = this),
      window.addEventListener('resize', () => {
        this.innerWidth = window.innerWidth
      }),
      this.transparentHeader && this.innerWidth > 1280
        ? this.domNodes.headerWrapper && this.domNodes.headerWrapper.classList.add('transparent-on-top')
        : this.domNodes.headerWrapper && this.domNodes.headerWrapper.classList.remove('transparent-on-top')
  }
  initAddon() {
    ;(this.megamenu = new Megamenu(this)),
      Shopify.designMode &&
        ((MinimogTheme = MinimogTheme || {}),
        MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount())
  }
  handleSticky() {
    let s = 20
    document.querySelectorAll('.shopify-section-group-header-group').forEach((e) => {
      e.classList.contains('m-section-header') || (s += e.offsetHeight)
    })
    const e = document.querySelector('.m-topbar')
    if ((e && (s += e.offsetHeight), !this.stickyEnabled)) return
    let t = 0
    window.addEventListener('scroll', () => {
      const e = window.scrollY
      if (e <= s)
        return (
          this.classList.remove(this.classes.scrollUp, this.classes.stuck),
          void (
            this.transparentHeader &&
            this.innerWidth > 1279 &&
            this.domNodes.headerWrapper &&
            this.domNodes.headerWrapper.classList.add('transparent-on-top')
          )
        )
      this.classList.add(this.classes.stuck),
        e > this.headerHeight + s && e > t && !this.classList.contains(this.classes.scrollDown)
          ? (this.classList.remove(this.classes.scrollUp), this.classList.add(this.classes.scrollDown))
          : e < t &&
            this.classList.contains(this.classes.scrollDown) &&
            (this.classList.remove(this.classes.scrollDown),
            this.classList.add(this.classes.scrollUp),
            this.transparentHeader &&
              this.innerWidth > 1279 &&
              this.domNodes.headerWrapper &&
              this.domNodes.headerWrapper.classList.remove('transparent-on-top')),
        (t = e)
    }, { passive: true })
  }
}
customElements.define('m-header', MHeader)

function wrapSingleLinks(container) {
  const ul = container.querySelector("ul.m-sub-menu.m-sub-menu--level-1");
  if (!ul) return;
  // Prevent double-wrapping on repeated mouseenter events
  if (ul.querySelector('.mega-menu-single-content')) return;

  const lis = Array.from(ul.children);
  const wrapper = document.createElement("div");
  wrapper.className = "mega-menu-single-content";

  lis.forEach(li => {
    const aTag = li.querySelector("a");
    const megaMenuDiv = li.querySelector("div.m-mega-menu__column");

    // Only wrap <li> that has only <a> and no mega menu column
    if (aTag && !megaMenuDiv) {
      wrapper.appendChild(li);
    }
  });

  // Only append if there are matching <li>s
  if (wrapper.children.length > 0) {
    ul.appendChild(wrapper);
  }
}

// Run once on load, not on every mouseenter
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.desktop-mega-menu-custom .m-menu__item').forEach(menuItem => {
    wrapSingleLinks(menuItem);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mobile-hem-menu-child-title").forEach(function (span) {
    if (span.textContent.trim() === "SHOP ALL") {
      // Hide the image in the same link
      let img = span.closest("a")?.querySelector("img");
      if (img) img.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapsible-UNDERWEAR .mobile-hem-menu-child-title").forEach(function (span) {
    if (span.textContent.trim() === "SHOP ALL") {
      let link = span.closest(".collapsible-UNDERWEAR .m-menu-mobile__link-2");
      if (link) {
        link.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0750/2191/0293/files/for_underwear.png?v=1754987792')";
        link.style.backgroundSize = "contain";
        link.style.backgroundRepeat = "no-repeat";
        link.style.backgroundPosition = "center";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapsible-BRALETTE .mobile-hem-menu-child-title").forEach(function (span) {
    if (span.textContent.trim() === "SHOP ALL") {
      let link = span.closest(".collapsible-BRALETTE .m-menu-mobile__link-2");
      if (link) {
        link.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0750/2191/0293/files/for_bralette.png?v=1754987792')";
        link.style.backgroundSize = "contain";
        link.style.backgroundRepeat = "no-repeat";
        link.style.backgroundPosition = "center";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapsible-men-UNDERWEAR .mobile-hem-menu-child-title").forEach(function (span) {
    if (span.textContent.trim() === "SHOP ALL") {
      let link = span.closest(".collapsible-men-UNDERWEAR .m-menu-mobile__link-2");
      if (link) {
        link.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0750/2191/0293/files/for_underwear_Men.png?v=1754987792')";
        link.style.backgroundSize = "contain";
        link.style.backgroundRepeat = "no-repeat";
        link.style.backgroundPosition = "center";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapsible-MATERNITY .mobile-hem-menu-child-title").forEach(function (span) {
    if (span.textContent.trim() === "SHOP ALL") {
      let link = span.closest(".collapsible-MATERNITY .m-menu-mobile__link-2");
      if (link) {
        link.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0750/2191/0293/files/for_underwear_Maternity.png?v=1755003609')";
        link.style.backgroundSize = "contain";
        link.style.backgroundRepeat = "no-repeat";
        link.style.backgroundPosition = "center";
      }
    }
  });
});